import { Injectable } from '@angular/core';

@Injectable()
export class ReportNavigatorService {
  private navItems:Map<String, Element>;
  constructor() { 
    this.navItems = new Map<String, Element>();
  }

  public hasNavigationItem(navId:string) {
    return this.navItems.has(navId);
  }

  public navigate(navId:string) : Promise<void> {
    let item = this.navItems.get(navId);
    if (item) {
      // TODO: stephen change out this hack to accomodate the fixed navbar at the top.
      let navBar = document.querySelector("dac-navbar nav");
      let navBarHeight = navBar ? navBar.clientHeight : 0; // if we have no navbar such as on the client we just skip.

      // adapted from https://stackoverflow.com/a/13857312
      item.scrollIntoView(true);
      var scrolledY = window.scrollY;
      
      if(scrolledY){
        window.scroll(0, scrolledY - navBarHeight);
      }
      
      return Promise.resolve();
    }
    return Promise.reject("item not found with id " + navId);
  }

  public registerItem(navId:string, element:Element) {
    this.navItems.set(navId, element);
  }

  public unregisterItem(navId:string) {
    this.navItems.delete(navId);
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/services/report-navigator.service.ts